
import { ScoreboardState } from "@/types/scoreboard";

/**
 * Generates a raw JSON string for vmix consumption
 * This function ensures the output is pure JSON without any HTML or other content
 */
export function generateRawJson(state: Partial<ScoreboardState>): string {
  const {
    team_a_score = 0,
    team_b_score = 0,
    team_a_hits = 0, 
    team_a_errors = 0,
    team_b_hits = 0,
    team_b_errors = 0,
    balls = 0,
    strikes = 0,
    outs = 0,
    inning = 0,
    is_top_inning = true,
    base_runners = [false, false, false],
    team_a_name = "Team A",
    team_b_name = "Team B",
  } = state;

  // Create the JSON data
  const jsonData = {
    scoreboard: {
      homeTeam: team_b_name || "Team B",
      awayTeam: team_a_name || "Team A",
      homeScore: team_b_score,
      awayScore: team_a_score,
      homeHits: team_b_hits,
      awayHits: team_a_hits,
      homeErrors: team_b_errors,
      awayErrors: team_a_errors,
      inning: inning === 99 ? "Final" : inning,
      inningHalf: is_top_inning ? "Top" : "Bottom",
      balls,
      strikes,
      outs,
      runnerOnFirst: base_runners[0] ? 1 : 0,
      runnerOnSecond: base_runners[1] ? 1 : 0,
      runnerOnThird: base_runners[2] ? 1 : 0
    }
  };

  // Return a clean JSON string without any BOM or special characters
  return JSON.stringify(jsonData);
} 
